export default "__VITE_ASSET__ClLmzLwe__"